import React from 'react';

// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

// Define the expected type for each menu item
interface MenuItemType {
  id: string;
  type: string;
  [key: string]: any; // allows additional properties (e.g., title, children)
}

const Navigation: React.FC = () => {
  const navGroups = (menuItem.items as MenuItemType[]).map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 0.5 }}>{navGroups}</Box>;
};

export default Navigation;
